import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'dialog-component';
import DialogContent from 'dialog-content-component';
import Icon from 'icon-component';
import Button from 'button-component';

const NoResultsDialog = ({
    isFiltered,
    onFilterResults,
    onResetFilters,
    onHidden
}) => {
    return (
        <Dialog
            className="NoResultsDialog"
            renderInBody={false}
            title="No Spots Found"
            onHidden={onHidden}
        >
            <DialogContent>
                <h3>
                    <Icon name="exclamation-circle" />
                    {(isFiltered) ? ` Looks like you've filtered yourself out of spots!` : ` We can't find any spots matching your search.`}
                </h3>
                {!isFiltered &&
                    <div>
                        <p className="subtitle">We don't want you going spotless, so try one of these tips to find parking.</p>
                        <p>Adjust your entry or exit times by an hour or two or try searching a nearby area.</p>
                    </div>
                }
                {isFiltered &&
                    <div>
                        <p>If these are criteria you can live without, <Button link onClick={onFilterResults}>Select Fewer Filters</Button> or <Button link onClick={onResetFilters}>Reset Filters</Button>.</p>
                        <p>Or, adjust your entry or exit times by an hour or two.</p>
                    </div>
                }
            </DialogContent>
        </Dialog>
    );
};

NoResultsDialog.propTypes = {
    isFiltered: PropTypes.bool,
    onFilterResults: PropTypes.func.isRequired,
    onResetFilters: PropTypes.func.isRequired,
    onHidden: PropTypes.func.isRequired
};

export default NoResultsDialog;



// WEBPACK FOOTER //
// ./spothero/static/main/js/search/components/common/NoResultsDialog.jsx